(function () {
  'use strict';

  function LoadingOverlay(target, timeout, opts) {
    // Set default values
    target = target || document.querySelector('body');
    timeout = timeout || 0;

    opts = opts || {};

    let defaults = {
      onClose: function () {},
    };

    opts = util.deepExtend(defaults, opts);

    // Check if target is selector or element
    let targetElement;
    if (typeof target === 'string') {
      targetElement = document.querySelector(target);
    } else {
      targetElement = target;
    }

    // Save target's position style
    let targetPositionStyle = targetElement.style.position;

    // Set target's position style to relative if needed
    if (getStyle(targetElement, 'position') === 'static') {
      targetElement.style.position = 'relative';
    }

    // Create overlay
    const overlay = document.createElement('div');
    overlay.classList.add('loadingOverlay');

    // Set overlay height
    if (targetElement.tagName === 'BODY') {
      overlay.style.position = 'fixed';
      overlay.style.height = 'var(--app-height)';
      overlay.style.minHeight = '100vh';
    } else {
      overlay.style.position = 'absolute';
      overlay.style.height = '100%';
    }

    // Create overlay icon
    const overlayIcon = document.createElement('div');
    overlayIcon.classList.add('loadingOverlay__icon');
    overlayIcon.innerHTML =
      '<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" stroke="currentColor"><g transform="translate(2 2)" stroke-width="4" fill="none" fill-rule="evenodd"><circle stroke-opacity=".5" cx="18" cy="18" r="18" /><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" /></path></g></svg>';

    // Add icon to overlay
    overlay.appendChild(overlayIcon);

    // Add overlay to target element
    targetElement.classList.add('loadingOverlay__container');
    targetElement.appendChild(overlay);

    // Auto-close overlay if timeout has been set
    if (timeout > 0) {
      window.setTimeout(() => {
        close();
      }, timeout);
    }

    function close() {
      targetElement.classList.remove('loadingOverlay__container');
      targetElement.removeChild(overlay);
      opts.onClose();

      if (targetPositionStyle === '') {
        targetElement.style.position = targetPositionStyle;
      } else {
        targetElement.style.removeProperty('position');
      }
    }

    function getStyle(element, styleProperty) {
      if (element.currentStyle) {
        return element.currentStyle[styleProperty];
      } else if (window.getComputedStyle) {
        return document.defaultView
          .getComputedStyle(element, null)
          .getPropertyValue(styleProperty);
      } else {
        return null;
      }
    }

    return {
      close: close,
    };
  }

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = LoadingOverlay;
  } else {
    window.LoadingOverlay = LoadingOverlay;
  }
})();
